import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

const ForecastHoursDetails = ({ open, onClose, scheduleData }) => {
  if (!scheduleData || scheduleData.length === 0) {
    return null;
  }

  const dayOrder = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const sortedScheduleDataDayWise = Array.isArray(scheduleData)
    ? [...scheduleData].sort(
        (firstSchedule, secondSchedule) =>
          dayOrder.indexOf(firstSchedule.day) -
          dayOrder.indexOf(secondSchedule.day)
      )
    : [];

  const totalForecastHours = sortedScheduleDataDayWise.reduce(
    (accumulatedHours, scheduleEntry) =>
      accumulatedHours + Number(scheduleEntry.totalDurationHour || 0),
    0
  );

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Schedule Details
          <IconButton onClick={onClose} size="small">
            <GridCloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Day</b>
                  </TableCell>
                  <TableCell>
                    <b>Start Time</b>
                  </TableCell>
                  <TableCell>
                    <b>End Time</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>Total Hours</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedScheduleDataDayWise.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.day}</TableCell>
                    <TableCell>{row.startTime}</TableCell>
                    <TableCell>{row.endTime}</TableCell>
                    <TableCell align="center">
                      {row.totalDurationHour}
                    </TableCell>
                  </TableRow>
                ))}
                {/* Total row */}
                <TableRow>
                  <TableCell colSpan={3}>
                    <b>Total Forecast Hours</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>{totalForecastHours.toFixed(2)}</b>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ForecastHoursDetails;